









































import { Component, Mixins } from 'vue-property-decorator';
import { ProfileFilter } from 'client-website-ts-library/filters';
import { Profile, WebsiteLevel, WebsiteProfileDisplayType } from 'client-website-ts-library/types';
import { API, Config } from 'client-website-ts-library/services';
import { View } from 'client-website-ts-library/plugins';

import Panels from '@/components/Panels.vue';
import ProfileCards from '../components/ProfileCards.vue';
import Loader from '../components/UI/Loader.vue';

@Component({
  components: {
    ProfileCards,
    Loader,
    Panels,
  },
})
export default class OurAgents extends Mixins(View) {
  private profiles: Profile[] = [];

  mounted() {
    const filter = new ProfileFilter();

    API.Profiles.Search(new ProfileFilter({
      SearchLevel: WebsiteLevel.Franchise,
      SearchGuid: Config.Website.Settings!.WebsiteId,
    }), true).then((profiles) => {
      const orderedProfiles: Profile[] = [];
      if (profiles.find((p) => p.Id === 'dbc21df2-268d-43da-a26c-da5711f7ee39') !== undefined) {
        // eslint-disable-next-line no-param-reassign
        orderedProfiles.push(profiles.find((p) => p.Id === 'dbc21df2-268d-43da-a26c-da5711f7ee39')!); // Robyn
      }
      if (profiles.find((p) => p.Id === '998d6fdc-8b5e-4864-9d82-ba9efb3c6629') !== undefined) {
        orderedProfiles.push(profiles.find((p) => p.Id === '998d6fdc-8b5e-4864-9d82-ba9efb3c6629')!); // Greg
      }
      if (profiles.find((p) => p.Id === 'cbdcbfd1-4184-4561-96f3-fed5de89d738') !== undefined) {
        orderedProfiles.push(profiles.find((p) => p.Id === 'cbdcbfd1-4184-4561-96f3-fed5de89d738')!); // Shane
      }

      if (profiles.find((p) => p.Id === '0b2b2a2b-ad70-4d54-9c72-4337a5e4319c') !== undefined) {
        orderedProfiles.push(profiles.find((p) => p.Id === '0b2b2a2b-ad70-4d54-9c72-4337a5e4319c')!); // Alison
      }
      if (profiles.find((p) => p.Id === 'c1919f30-ed53-4abe-9010-4a2a86aa2d39') !== undefined) {
        orderedProfiles.push(profiles.find((p) => p.Id === 'c1919f30-ed53-4abe-9010-4a2a86aa2d39')!); // Brian
      }
      if (profiles.find((p) => p.Id === '8344835b-54ce-49f3-b714-98fc55462acc') !== undefined) {
        orderedProfiles.push(profiles.find((p) => p.Id === '8344835b-54ce-49f3-b714-98fc55462acc')!); // Debbie
      }
      if (profiles.find((p) => p.Id === 'b1e78242-2851-4edb-b4bf-50459e70c8fa') !== undefined) {
        orderedProfiles.push(profiles.find((p) => p.Id === 'b1e78242-2851-4edb-b4bf-50459e70c8fa')!); // Oliver
      }
      if (profiles.find((p) => p.Id === '77cbc9c9-fdc7-4cbd-bb36-f53eff2de648') !== undefined) {
        orderedProfiles.push(profiles.find((p) => p.Id === '77cbc9c9-fdc7-4cbd-bb36-f53eff2de648')!); // Peter
      }
      if (profiles.find((p) => p.Id === '13e8bbe2-5321-4c75-a61c-803b7cafd670') !== undefined) {
        orderedProfiles.push(profiles.find((p) => p.Id === '13e8bbe2-5321-4c75-a61c-803b7cafd670')!); // Steve Habjan
      }
      if (profiles.find((p) => p.Id === 'a1bffeb5-1ffb-44e9-8939-5d6c548472d2') !== undefined) {
        orderedProfiles.push(profiles.find((p) => p.Id === 'a1bffeb5-1ffb-44e9-8939-5d6c548472d2')!); // Michelle
      }
      if (profiles.find((p) => p.Id === 'e69c060e-60c0-4458-b535-a680c21beeb7') !== undefined) {
        orderedProfiles.push(profiles.find((p) => p.Id === 'e69c060e-60c0-4458-b535-a680c21beeb7')!); // Renee S
      }
      if (profiles.find((p) => p.Id === '833fca72-1029-478b-aafb-dead55346653') !== undefined) {
        orderedProfiles.push(profiles.find((p) => p.Id === '833fca72-1029-478b-aafb-dead55346653')!); // Kelly Hill
      }
      if (profiles.find((p) => p.Id === 'db9703d1-176f-48f9-b99f-380db9ecfad1') !== undefined) {
        orderedProfiles.push(profiles.find((p) => p.Id === 'db9703d1-176f-48f9-b99f-380db9ecfad1')!); // Dean
      }
      if (profiles.find((p) => p.Id === 'cfa89bbc-b396-436e-9412-3abe8abf6050') !== undefined) {
        orderedProfiles.push(profiles.find((p) => p.Id === 'cfa89bbc-b396-436e-9412-3abe8abf6050')!); // Kerry
      }
      if (profiles.find((p) => p.Id === 'c1fd66c1-93e5-4cde-acbe-358935450899') !== undefined) {
        orderedProfiles.push(profiles.find((p) => p.Id === 'c1fd66c1-93e5-4cde-acbe-358935450899')!); // Jill
      }
      if (profiles.find((p) => p.Id === 'c9c2fc74-45c6-45dc-ac84-1284916d739e') !== undefined) {
        orderedProfiles.push(profiles.find((p) => p.Id === 'c9c2fc74-45c6-45dc-ac84-1284916d739e')!); // Tania
      }
      if (profiles.find((p) => p.Id === '5baa46ed-1a07-4a8c-8db7-006568debf96') !== undefined) {
        orderedProfiles.push(profiles.find((p) => p.Id === '5baa46ed-1a07-4a8c-8db7-006568debf96')!); // Ian
      }
      if (profiles.find((p) => p.Id === 'b0322d0e-7400-4496-af1d-0c090e1d8d31') !== undefined) {
        orderedProfiles.push(profiles.find((p) => p.Id === 'b0322d0e-7400-4496-af1d-0c090e1d8d31')!); // Michael
      }
      if (profiles.find((p) => p.Id === '1eb5f4f4-ab74-43db-aa17-a9db94eace84') !== undefined) {
        orderedProfiles.push(profiles.find((p) => p.Id === '1eb5f4f4-ab74-43db-aa17-a9db94eace84')!); // Jen Meibusch
      }
      if (profiles.find((p) => p.Id === 'bfcf99a6-b7bb-41d3-a526-991b2b8b0efa') !== undefined) {
        orderedProfiles.push(profiles.find((p) => p.Id === 'bfcf99a6-b7bb-41d3-a526-991b2b8b0efa')!); // Cecilia
      }
      if (profiles.find((p) => p.Id === '47f5459d-a697-48bc-8f41-398faf49bc38') !== undefined) {
        orderedProfiles.push(profiles.find((p) => p.Id === '47f5459d-a697-48bc-8f41-398faf49bc38')!); // Josephina
      }
      if (profiles.find((p) => p.Id === '1d675899-cfc9-4dd3-a8d3-4288e03fa177') !== undefined) {
        orderedProfiles.push(profiles.find((p) => p.Id === '1d675899-cfc9-4dd3-a8d3-4288e03fa177')!); // Steve Coates
      }
      /* if (profiles.find((p) => p.Id === '6ec7e254-de42-4c9a-a600-099f0ee81a45') !== undefined) {
        orderedProfiles.push(profiles.find((p) => p.Id === '6ec7e254-de42-4c9a-a600-099f0ee81a45')!); // Larry
      }
      if (profiles.find((p) => p.Id === 'b906cb20-0381-4eb7-a641-aeb1a6a26535') !== undefined) {
        orderedProfiles.push(profiles.find((p) => p.Id === 'b906cb20-0381-4eb7-a641-aeb1a6a26535')!); // Cyndi
      } */
      // orderedProfiles.push(profiles.find((p) => p.Id === '')!); // Kirsty

      if (profiles.find((p) => p.Id === 'b05e2144-079b-4b53-9f7e-9f7c1f07ddeb') !== undefined) {
        orderedProfiles.push(profiles.find((p) => p.Id === 'b05e2144-079b-4b53-9f7e-9f7c1f07ddeb')!); // Samantha
      }
      if (profiles.find((p) => p.Id === '1980d31c-fe14-4f77-b1d4-6c2c20f4609a') !== undefined) {
        orderedProfiles.push(profiles.find((p) => p.Id === '1980d31c-fe14-4f77-b1d4-6c2c20f4609a')!); // Meeka
      }
      if (profiles.find((p) => p.Id === '9c46f9ed-d200-49ad-8a45-ac9279610ef8') !== undefined) {
        orderedProfiles.push(profiles.find((p) => p.Id === '9c46f9ed-d200-49ad-8a45-ac9279610ef8')!); // Debra Gray
      }
      if (profiles.find((p) => p.Id === 'f42c5b46-cf11-4b6b-a227-0e8663d7dd43') !== undefined) {
        orderedProfiles.push(profiles.find((p) => p.Id === 'f42c5b46-cf11-4b6b-a227-0e8663d7dd43')!); // Kimberley
      }
      if (profiles.find((p) => p.Id === 'e1a4613c-55f2-4752-8c31-289f8532b0d4') !== undefined) {
        orderedProfiles.push(profiles.find((p) => p.Id === 'e1a4613c-55f2-4752-8c31-289f8532b0d4')!); // Chris
      }
      if (profiles.find((p) => p.Id === '9827be5d-afe4-4628-bc06-13c365621026') !== undefined) {
        orderedProfiles.push(profiles.find((p) => p.Id === '9827be5d-afe4-4628-bc06-13c365621026')!); // Jamie Condran
      }
      // orderedProfiles.push(profiles.find((p) => p.Id === '')!); // Jamie Lee

      // orderedProfiles.push(profiles.find((p) => p.Id === '')!); // Karmen
      if (profiles.find((p) => p.Id === '55b77f2e-712a-44c9-af0f-ddfb9f2928bb') !== undefined) {
        orderedProfiles.push(profiles.find((p) => p.Id === '55b77f2e-712a-44c9-af0f-ddfb9f2928bb')!); // Kim
      }
      // orderedProfiles.push(profiles.find((p) => p.Id === '')!); // Jean
      // orderedProfiles.push(profiles.find((p) => p.Id === '')!); // Anta
      // orderedProfiles.push(profiles.find((p) => p.Id === '')!); // Naomi
      // orderedProfiles.push(profiles.find((p) => p.Id === '')!); // South
      // orderedProfiles.push(profiles.find((p) => p.Id === '')!); // Amelia
      // orderedProfiles.push(profiles.find((p) => p.Id === '')!); // Kerry Ross

      this.profiles = orderedProfiles.concat(profiles.filter((x) => !orderedProfiles.includes(x)));
    });
  }

  get directors(): Profile[] {
    return this.profiles.filter((p) => p.DisplayType === WebsiteProfileDisplayType.Principal);
  }

  get agents(): Profile[] {
    return this.profiles.filter((p) => p.DisplayType === WebsiteProfileDisplayType.Agent);
  }

  get propertyManagers(): Profile[] {
    return this.profiles.filter((p) => p.DisplayType === WebsiteProfileDisplayType.PropertyManager);
  }

  get support(): Profile[] {
    return this.profiles.filter((p) => p.DisplayType === WebsiteProfileDisplayType.PersonalAssistant || p.DisplayType === WebsiteProfileDisplayType.Office);
  }
}
